// NPM imports

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';

// Project imports

import SubHeader from '../../components/SubHeader';
import Tabs, { Tab } from '../../components/Tabs';
import { rolesList } from '../../redux/auth';

// Module imports

import AdminLuftUsers from './pages/AdminLuftUsers';
import AdminCompanies from './pages/AdminCompanies';
import AdminPlatformUsers from './pages/AdminPlatformUsers';
import { Container } from './styles';

// Component

class Admin extends Component {
  constructor(props) {
    super(props);

    const { match, roles } = props;

    let tabs;

    if (roles.indexOf(rolesList.ADMINISTRATOR) !== -1) {
      tabs = [
        {
          text: 'Usuários plataforma',
          path: `${match.path}/usuarios`,
          component: AdminPlatformUsers,
        },
        {
          text: 'Empresas',
          path: `${match.path}/empresas`,
          component: AdminCompanies,
        },
        // {
        //   text: 'Usuários Luft',
        //   path: `${match.path}/usuarios-luft`,
        //   component: AdminLuftUsers,
        // },
      ];
    } else if (roles.indexOf(rolesList.ADMIN_CUSTOMER) !== -1) {
      tabs = [
        {
          text: 'Usuários plataforma',
          path: `${match.path}/usuarios`,
          component: AdminLuftUsers,
        },
      ];
    }

    this.state = { tabs };
  }

  _renderTabs = () => (
    <Tabs>
      {
          this.state.tabs.map((tab, i) => (
            <Tab
              isActive={tab.path === this.props.location.pathname}
              onClick={() => this.props.history.push(tab.path)}
              key={i}
            >
              {tab.text}
            </Tab>
          ))
        }
    </Tabs>
  )

  _renderRoutes = () => (
    <Switch>
      {
          this.state.tabs.map((tab, i) => (
            <Route
              path={tab.path}
              component={tab.component}
              key={i}
            />
          ))
        }

      {/* default tab */}
      <Redirect to={this.state.tabs[0].path} />
    </Switch>
  )

  render() {
    return (
      <Container>
        <SubHeader
          title="Painel Administrativo"
          renderSide={this._renderTabs}
        />
        {this._renderRoutes()}
      </Container>
    );
  }
}

// Redux

const mapStateToProps = state => ({
  roles: state.auth.roles,
});

export default connect(mapStateToProps)(Admin);
